
import { defineComponent, PropType, ref, watch } from 'vue'
import { CtClient } from '@/models/interfaces/content-type'
import EditableBlock from '@/components/EditableBlock.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'

export default defineComponent({
  name: 'AccountingDetails',
  components: { EditableBlockInput, EditableBlock },
  props: {
    client: {
      type: Object as PropType<CtClient>,
      required: true,
    },
  },
  emits: ['update:client'],
  setup (props) {

    const accountingDetails = ref(props.client.accounting_details ?? {})

    watch(() => props.client, () => {
      accountingDetails.value = props.client.accounting_details ?? {}
    })

    return {
      accountingDetails,
    }
  }
})
